import { useEffect, useState } from 'react'

/**
 * Defers mounting the native camera view until the rest of the flow UI
 * (MeasurementMessages etc.) has had a frame to mount and paint. The
 * camera's native session init can block the UI thread on mount, so without
 * an explicitly painted frame first the flow would open on a black screen.
 * The double `requestAnimationFrame` spans that first paint: the inner
 * callback runs only after the frame scheduled by the outer one has been
 * presented.
 */
export function useCameraMountAfterPaint() {
  const [isCameraReady, setIsCameraReady] = useState(false)

  useEffect(() => {
    let frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => setIsCameraReady(true))
    })

    return () => cancelAnimationFrame(frame)
  }, [])

  return isCameraReady
}
